import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon/fb.svg'
import _imports_1 from '@/assets/img/icon/ins.svg'
import _imports_2 from '@/assets/img/icon/tw.svg'
import _imports_3 from '@/assets/img/icon/pn.svg'


const _hoisted_1 = {
  key: 0,
  class: "instructor-single-details ptb-100"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "instructor-sidebar-sticky" }
const _hoisted_6 = { class: "image" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "instructor-content" }
const _hoisted_10 = { class: "instructor-info" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-envelope" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-phone" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-map" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "instructor-social"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", null, "Beni Takip Et:", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "facebook"
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "instagram"
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "twitter"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { key: 3 }
const _hoisted_29 = ["href"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "pinterest"
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "col-lg-8" }
const _hoisted_33 = { class: "instructor-single-content" }
const _hoisted_34 = { class: "sub-title" }
const _hoisted_35 = {
  key: 1,
  class: "container ptb-100"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", null, "Eğitmen bulunamadı.", -1)
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.instructor)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.instructor.image,
                    alt: _ctx.instructor.name
                  }, null, 8, _hoisted_7)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.instructor.name), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.instructor.bio), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_11,
                        _createElementVNode("span", null, _toDisplayString(_ctx.instructor.email), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_12,
                        _createElementVNode("span", null, _toDisplayString(_ctx.instructor.phone), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_13,
                        _createElementVNode("span", null, _toDisplayString(_ctx.instructor.address), 1)
                      ])
                    ])
                  ]),
                  (_ctx.instructor.socials)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("ul", null, [
                          (_ctx.instructor.socials.facebook)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                                _createElementVNode("a", {
                                  href: _ctx.instructor.socials.facebook,
                                  target: "_blank"
                                }, _hoisted_19, 8, _hoisted_17)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.instructor.socials.instagram)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                _createElementVNode("a", {
                                  href: _ctx.instructor.socials.instagram,
                                  target: "_blank"
                                }, _hoisted_23, 8, _hoisted_21)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.instructor.socials.twitter)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                                _createElementVNode("a", {
                                  href: _ctx.instructor.socials.twitter,
                                  target: "_blank"
                                }, _hoisted_27, 8, _hoisted_25)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.instructor.socials.pinterest)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                _createElementVNode("a", {
                                  href: _ctx.instructor.socials.pinterest,
                                  target: "_blank"
                                }, _hoisted_31, 8, _hoisted_29)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.instructor.name), 1),
                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.instructor.title), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.instructor.bio), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.instructor.description), 1)
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
}